import apiClient from '../appConfig/interceptor';
import { endpoints } from '../utils/constants';

const getWorkItemsState = (selectedProduct:string) => apiClient.get(`${endpoints.pathPrefix}workItem/states?product=${selectedProduct}`);
const getItemLifeCycle = (searchUrl:string,selectedProduct:string) => apiClient.get(`${endpoints.pathPrefix}workItem?id=${searchUrl}&product=${selectedProduct}`);
const getWorkItemDetails = (id: number, selectedProduct: string) => apiClient.get(`${endpoints.pathPrefix}workItem/state/${id}?product=${selectedProduct}`);

const itemDetailsApiList = {
  getWorkItemsState,
  getItemLifeCycle,
  getWorkItemDetails
};
export default itemDetailsApiList;
